export default "__VITE_ASSET__CA2siok7__"